//import PDFJS from "pdfjs-dist";

import load from "@/conf/js/load";

export default {

    updateSuccess : {},
    successFunction : {},
    box_width: 0,


    /**
     * 绘图
     * @param pdf
     */
    pdf2Canvas(pdf) {
        for (let i = 1; i <= pdf.numPages; i++) {
            //开始处理
            pdf.getPage(i).then(page => {
                let canvas = document.getElementById("canvas-read-pdf-box-" + (i - 1));

                let ctx = canvas.getContext("2d");
                let viewport = page.getViewport({ scale: 0.5 });
                viewport = page.getViewport({ scale: this.box_width / viewport.width });
                canvas.width = viewport.width;
                canvas.height = viewport.height;
                canvas.style.width = (viewport.width / 2) + "px";
                canvas.style.height = (viewport.height / 2) + "px";
                //传递父页面高度,以方便骑缝章使用
                this.updateSuccess({
                    naturalHeight : viewport.height/2,
                    naturalWidth : viewport.width/2,
                    el : canvas
                })
                // this._self.doc_page_height = viewport.height / 2;
                 page.render({ canvasContext: ctx, viewport: viewport });
            });
            //处理完成
        }
    },
    /**
     * 加载pdf
     * @param url
     * @param box_width
     * @param successFunction
     * @param updateSuccess
     */
    load(url, box_width, successFunction, updateSuccess) {
        this.box_width = box_width;
        this.successFunction = successFunction
        this.updateSuccess = updateSuccess
        load.js("https://web.1dq.com/static/js/pdf/pdf.js", () => {
            this.pdfHandle(url)
        });
    },



     pdfHandle(url) {

        pdfjsLib.GlobalWorkerOptions.workerSrc = "https://web.1dq.com/static/js/pdf/pdf.worker.js";
        pdfjsLib.getDocument({
            url: url, // PDF base64编码
            cMapUrl: "https://oss2.1dq.com/pdf/js/cmaps/",
            cMapPacked: true
        }).promise.then((pdf) => {


            //页面信息
            let pages = [];
            for (let i = 1; i <= pdf.numPages; i++) {
                pages.push({
                    place_data: [],
                    signed_data: [],
                    url: "",
                    type: "svg"
                });
            }

            this.successFunction(pages)

            //绘图
            this.pdf2Canvas(pdf);

        });

    }

};
